//DialogHeader.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024. (Modified for Homeplus project)
import { Box, Fab } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PlusMark from '../asset/image/plusmark.svg';
import HomeplusText from '../asset/image/homeplus_no_line.svg';

const ImageLogoSize = 18;

const DialogHeaderContainer = styled(Box)({
    backgroundColor: '#fff9f9', color: 'df0011',
    textAlign: 'left', position: 'relative', borderBottom: '2px solid #df0011',
    paddingBottom: 10, minHeight: 40,
});

const LogoAndFab = styled(Box)({display: 'flex', alignItems: 'center', marginTop:12, marginBottom:12});
const LogoColumn = styled(Box)({flexGrow: 1, display: 'flex', alignItems: 'center'});
const FabColumn = styled(Box)({flexGrow: 0, textAlign: 'right'});
const ImageLogoBox = styled('div')({
    width:ImageLogoSize, height:ImageLogoSize, textAlign:'center',
    marginLeft:10, padding:4, borderRadius:18, 
    display: 'inline-block', backgroundColor:'#cef'
});
const CloseFab = styled(Fab)({
    position: 'absolute', top:20, right:20, backgroundColor: 'darkorange',
});

export default function DialogHeader({
    title, onClose
}) {

    const onClickCloseIcon = () => {
        onClose();
    }

    return(
        <DialogHeaderContainer minWidth={400}>
            <LogoAndFab>
                <LogoColumn>
                    <ImageLogoBox><img src={PlusMark} height={ImageLogoSize} alt='Homeplus(+)'/></ImageLogoBox>
                    <img src={HomeplusText}
                        style={{marginLeft:10}}
                        height={ImageLogoSize*4/5} alt="Homeplus(text)"
                    />
                </LogoColumn>
                <FabColumn>
                    {
                        onClose ?
                        <CloseFab
                            onClick={onClickCloseIcon}>
                            <CloseIcon />
                        </CloseFab>
                        : null
                    }
                </FabColumn>
            </LogoAndFab>
            <Box style={{paddingLeft:40}}>
                <span style={{fontSize:'16pt', fontWeight:'bold'}}>
                    {title}
                </span>
            </Box>
            
        </DialogHeaderContainer>
    );
}
